export const godfatherStatuses = {
    WAITING_FIRST_MISSION: 0,
    FIRST_MISSION_DONE: 1,
    PAYMENT_DONE: 2,
}